'use client';

import React from 'react';

import { Body, Heading } from '@depop/web-thrift-ui/Typography';
import { ClothesIcon } from '@depop/web-ui-kit/Icons/ClothesIcon';
import { useParams } from 'next/navigation';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { ExtendedLink } from '@/components/ExtendedLink';
import { ActivityTrackerEventType } from '@/modules/activityTracker/constants.ts';
import { useActivityTracker } from '@/modules/activityTracker/useActivityTracker.ts';
import { useCurrentUser } from '@/modules/user/useCurrentUser.ts';

export function ListOneLikeThis() {
  const t = useTranslations('product');
  const { slug } = useParams<{ slug: string }>();
  const [isAuthenticated, currentUser] = useCurrentUser();
  const { sendActivityTrackerEvent } = useActivityTracker({
    userId: currentUser?.id,
  });

  async function handleListOneLikeThisClick() {
    await sendActivityTrackerEvent(
      ActivityTrackerEventType.START_LISTING_ACTION,
      {
        type: 'ListSimilar',
      }
    );
  }

  if (!isAuthenticated) {
    return <></>;
  }

  return (
    <div className={styles.wrapper}>
      <ClothesIcon size={30} className={styles.clothesIcon} />
      <div>
        <Heading variant="sm">{t('GotOneLikeThis')}</Heading>

        <ExtendedLink
          href={`/products/create?copyFromSlug=${encodeURIComponent(
            slug
          )}&cta=ProductPage.ListSimilar`}
          onClick={handleListOneLikeThisClick}
        >
          <Body variant="sm-regular" className={styles.seeSimilarItemsText}>
            {t('SellASimilarItem')}
          </Body>
        </ExtendedLink>
      </div>
    </div>
  );
}
